export default "__VITE_ASSET__87dd52f5__"